export default {"src":"/_next/static/media/sticker-1.2dfdd9f9.svg","height":180,"width":179,"blurWidth":0,"blurHeight":0};